import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'ts-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ImageComponent implements OnChanges, OnDestroy {
  @Input() public url: string;
  @Input() public scale = 1;

  public loading = true;
  public safeUrl: SafeUrl;

  private image: HTMLImageElement;

  constructor(private readonly sanitizer: DomSanitizer, private readonly cdr: ChangeDetectorRef) {}

  public ngOnDestroy(): void {
    if (this.image) this.image.onload = null;
  }

  public ngOnChanges({ url }: SimpleChanges): void {
    if (!url) return;

    const { currentValue, previousValue } = url;

    if (currentValue === previousValue) return;

    if (!currentValue) {
      this.clearImage();
      return;
    }

    this.loadImage(currentValue);
  }

  private clearImage(): void {
    this.loading = true;
    this.safeUrl = undefined;

    if (this.image) {
      this.image.onload = null;
      this.image.src = '';
    }

    this.cdr.markForCheck();
  }

  private renderImage() {
    this.loading = false;
    this.cdr.markForCheck();
  }

  private loadImage(url: string) {
    if (!this.image) this.image = new Image();

    this.safeUrl = this.sanitizer.bypassSecurityTrustUrl(url);

    this.image.src = url;

    if (this.image.complete) {
      this.renderImage();
    } else {
      this.loading = true;
      this.image.onload = () => this.renderImage();
    }
  }
}
